/**
 * Qubool Crafts — Globo form helpers
 * - Rename properties[text-1] → human labels (DOM + cart payloads + cart heal)
 * - Calendar-only date fields (no typing)
 * - Islamic (Umm al-Qura) auto-fill
 */
(function () {
  'use strict';

  var GREGORIAN_LABEL = /date of (nikkah|event|wedding|ceremony)/i;
  var HIJRI_LABEL = /islamic date|hijri|corresponding islamic/i;
  var NAME_LABEL = /name of (groom|bride)|groom first|bride first/i;
  var INTERNAL_PROP = /^(text|select|textarea|checkbox|radio|file|swatch|datepicker)-\d+$/i;
  var MAP_KEY = 'qcPropLabelMap';

  /* Fallback when map not in session (cart page after ATC from another tab) */
  var FALLBACK_NIKKAH = {
    'text-1': 'Full Name of Groom',
    'text-2': 'Full Name of Bride',
    'text-3': 'City & State of Nikkah',
    'text-4': 'Date of Nikkah',
    'text-5': 'Islamic Date',
    'text-6': 'Mahr (Optional)',
    'text-7': 'Additional Notes (Optional)',
    'select-1': 'Signatories',
  };

  /* Checkout/cart show properties in insertion order — keep personalization first, processing last */
  var PREFERRED_ORDER = [
    'Full Name of Groom',
    'Full Name of Bride',
    'City & State of Nikkah',
    'Date of Nikkah',
    'Islamic Date',
    'Signatories',
    'Mahr (Optional)',
    'Additional Notes (Optional)',
    'Groom First Name',
    'Bride First Name',
    'Date of Event',
    'Additional Notes',
    'Text',
  ];
  var FALLBACK_TRAY = {
    'text-1': 'Groom First Name',
    'text-2': 'Bride First Name',
    'text-3': 'Date of Event',
    'text-4': 'Additional Notes',
  };

  function labelText(el) {
    if (!el) return '';
    if (el.id) {
      var byFor = document.querySelector('label[for="' + CSS.escape(el.id) + '"]');
      if (byFor) return (byFor.textContent || '').trim();
    }
    if (el.labels && el.labels.length) return (el.labels[0].textContent || '').trim();
    var group = el.closest('.gpo-form__group, .gpo-element');
    if (!group) return '';
    var label = group.querySelector('.gpo-label .label-content, .gpo-label, label');
    return ((label && label.textContent) || '').trim();
  }

  function cleanPropName(raw) {
    return String(raw || '')
      .replace(/\s*\*\s*$/, '')
      .replace(/:\s*$/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function canonicalPropName(raw) {
    var cleaned = cleanPropName(raw);
    if (HIJRI_LABEL.test(cleaned) || /^corresponding islamic date$/i.test(cleaned)) {
      return 'Islamic Date';
    }
    return cleaned;
  }

  function renameIslamicFormLabels(root) {
    var hijri = findField(root, HIJRI_LABEL);
    if (!hijri) return;
    var nodes = [];
    if (hijri.id) {
      var byFor = document.querySelector('label[for="' + CSS.escape(hijri.id) + '"]');
      if (byFor) nodes.push(byFor);
    }
    var group = hijri.closest('.gpo-form__group, .gpo-element');
    if (group) {
      var content = group.querySelector('.gpo-label .label-content, .gpo-label');
      if (content) nodes.push(content);
    }
    nodes.forEach(function (node) {
      if (!node || !/corresponding\s+islamic/i.test(node.textContent || '')) return;
      var required = node.querySelector('.required, [class*="required"]');
      var requiredHtml = required ? required.outerHTML : '';
      if (/corresponding\s+islamic\s+date/i.test(node.textContent || '')) {
        node.innerHTML = 'Islamic Date' + (requiredHtml ? ' ' + requiredHtml : '');
      }
    });
  }

  function findField(root, pattern) {
    var scope = root && root.querySelectorAll ? root : document;
    var inputs = scope.querySelectorAll('.gpo-app input, .gpo-app textarea, .gpo-app select');
    for (var i = 0; i < inputs.length; i++) {
      if (pattern.test(labelText(inputs[i]))) return inputs[i];
    }
    return null;
  }

  function ensureHint(input, id, text) {
    if (!input) return;
    var group = input.closest('.gpo-form__group, .gpo-element') || input.parentElement;
    if (!group) return;
    var existing = group.querySelector('[data-qc-hint="' + id + '"]');
    if (existing) {
      if (existing.textContent !== text) existing.textContent = text;
      return existing;
    }
    var hint = document.createElement('p');
    hint.className = 'qc-field-hint';
    hint.setAttribute('data-qc-hint', id);
    hint.textContent = text;
    var wrap = input.closest('.gpo-input-wrap') || input.parentElement;
    if (wrap && wrap.parentElement) wrap.parentElement.insertBefore(hint, wrap.nextSibling);
    else group.appendChild(hint);
    return hint;
  }

  function setNativeValue(input, value, silent) {
    var proto =
      input.tagName === 'TEXTAREA'
        ? window.HTMLTextAreaElement.prototype
        : window.HTMLInputElement.prototype;
    var setter = Object.getOwnPropertyDescriptor(proto, 'value');
    if (setter && setter.set) setter.set.call(input, value);
    else input.value = value;
    if (!silent) {
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function normalizeProcessingValue(val) {
    if (typeof val !== 'string') return val;
    return val.replace(/(\d)\s*[–—-]\s*(\d)/g, '$1–$2');
  }

  function loadLabelMap() {
    try {
      return JSON.parse(sessionStorage.getItem(MAP_KEY) || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function saveLabelMap(map) {
    try {
      var prev = loadLabelMap();
      var merged = Object.assign({}, prev, map);
      sessionStorage.setItem(MAP_KEY, JSON.stringify(merged));
    } catch (e) {
      /* private mode */
    }
  }

  function getLabelMap() {
    var map = loadLabelMap();
    var gpo = document.querySelector('.gpo-app');
    if (gpo) {
      gpo.querySelectorAll('[data-qc-old-key][data-qc-prop]').forEach(function (el) {
        map[el.getAttribute('data-qc-old-key')] = el.getAttribute('data-qc-prop');
      });
    }
    return map;
  }

  function guessFallbackMap(props, title) {
    var keys = Object.keys(props || {});
    var hasSelect = keys.some(function (k) {
      return /^select-\d+$/i.test(k);
    });
    var t = String(title || '').toLowerCase();
    if (hasSelect || /nikkah|certificate|contract/.test(t)) return FALLBACK_NIKKAH;
    if (/tray|resin|ring/.test(t)) return FALLBACK_TRAY;
    return FALLBACK_NIKKAH;
  }

  /* ---------- Property names: text-1 → human labels ---------- */

  function rewritePropertyNames(root) {
    renameIslamicFormLabels(root);
    var scope = root && root.querySelectorAll ? root : document;
    var fields = scope.querySelectorAll(
      '.gpo-app input[name^="properties["], .gpo-app textarea[name^="properties["], .gpo-app select[name^="properties["], .gpo-app input[data-name^="properties["], .gpo-app select[data-name^="properties["], .gpo-app textarea[data-name^="properties["]'
    );
    var map = {};
    for (var i = 0; i < fields.length; i++) {
      var el = fields[i];
      var label = canonicalPropName(labelText(el));
      if (!label) continue;

      var currentName = el.getAttribute('name') || el.getAttribute('data-name') || '';
      var keyMatch = currentName.match(/^properties\[([^\]]+)\]$/);
      var currentKey = keyMatch ? keyMatch[1] : '';

      var needsRename =
        (currentKey && INTERNAL_PROP.test(currentKey)) ||
        /^corresponding islamic date$/i.test(currentKey || '');

      if (currentKey && !needsRename && currentKey === label) continue;
      if (currentKey && !needsRename && !/^corresponding islamic date$/i.test(currentKey)) {
        continue;
      }

      if (currentKey && INTERNAL_PROP.test(currentKey)) {
        el.setAttribute('data-qc-old-key', currentKey);
        map[currentKey] = label;
      }
      if (/^corresponding islamic date$/i.test(currentKey || '')) {
        map['Corresponding Islamic Date'] = 'Islamic Date';
        map['text-5'] = 'Islamic Date';
      }

      var next = 'properties[' + label + ']';
      if (el.getAttribute('name')) el.setAttribute('name', next);
      if (el.getAttribute('data-name')) el.setAttribute('data-name', next);
      el.setAttribute('data-qc-prop', label);
    }
    map['Corresponding Islamic Date'] = 'Islamic Date';
    map['text-5'] = map['text-5'] || 'Islamic Date';
    saveLabelMap(map);
  }

  function orderProperties(props) {
    var underscored = {};
    var processingVal = null;
    var hasProcessing = false;
    var pool = {};

    Object.keys(props).forEach(function (k) {
      if (k.charAt(0) === '_') {
        underscored[k] = props[k];
        return;
      }
      if (/^processing time$/i.test(k)) {
        hasProcessing = true;
        processingVal = normalizeProcessingValue(props[k]);
        return;
      }
      var key = /^corresponding islamic date$/i.test(k) ? 'Islamic Date' : k;
      pool[key] = props[k];
    });

    var out = Object.assign({}, underscored);
    PREFERRED_ORDER.forEach(function (name) {
      if (Object.prototype.hasOwnProperty.call(pool, name)) {
        out[name] = pool[name];
        delete pool[name];
      }
    });
    Object.keys(pool).forEach(function (k) {
      out[k] = pool[k];
    });
    if (hasProcessing) out['Processing time'] = processingVal;
    return out;
  }

  function remapPropertiesObject(props, title) {
    if (!props || typeof props !== 'object') return props;
    var map = Object.assign(
      { 'Corresponding Islamic Date': 'Islamic Date' },
      guessFallbackMap(props, title),
      getLabelMap()
    );
    var renamed = {};
    var changed = false;
    Object.keys(props).forEach(function (k) {
      var nextKey = map[k] || k;
      if (/^corresponding islamic date$/i.test(nextKey)) nextKey = 'Islamic Date';
      var val = props[k];
      if (/^processing time$/i.test(nextKey) || /^processing time$/i.test(k)) {
        val = normalizeProcessingValue(val);
      }
      if (nextKey !== k || val !== props[k]) changed = true;
      renamed[nextKey] = val;
    });
    var ordered = orderProperties(renamed);
    var beforeKeys = Object.keys(props).join('\0');
    var afterKeys = Object.keys(ordered).join('\0');
    if (beforeKeys !== afterKeys) changed = true;
    return changed ? ordered : props;
  }

  function propertiesNeedHeal(props) {
    if (!props) return false;
    var keys = Object.keys(props);
    var visible = keys.filter(function (k) {
      return k.charAt(0) !== '_';
    });
    if (
      visible.some(function (k) {
        return INTERNAL_PROP.test(k) || /^corresponding islamic date$/i.test(k);
      })
    ) {
      return true;
    }
    if (
      visible.some(function (k) {
        return /^processing time$/i.test(k) && /\d\s+[–—-]\s+\d/.test(String(props[k]));
      })
    ) {
      return true;
    }
    var procIdx = -1;
    var islamicIdx = -1;
    for (var i = 0; i < visible.length; i++) {
      if (/^processing time$/i.test(visible[i])) procIdx = i;
      if (/islamic date/i.test(visible[i])) islamicIdx = i;
    }
    /* Islamic Date must appear before Processing time in checkout */
    if (procIdx >= 0 && islamicIdx >= 0 && islamicIdx > procIdx) return true;
    if (procIdx >= 0 && procIdx !== visible.length - 1) return true;
    return false;
  }

  function healCartLine(item, line) {
    if (!propertiesNeedHeal(item.properties)) return Promise.resolve(false);
    var next = remapPropertiesObject(Object.assign({}, item.properties), item.product_title);
    if (next === item.properties) next = orderProperties(Object.assign({}, item.properties));
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: item.quantity,
        properties: next,
      }),
    }).then(function (r) {
      return r.ok;
    });
  }

  function healCartProperties() {
    return fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return false;
        var chain = Promise.resolve(false);
        /* Heal from last line to first so line indices stay stable */
        for (var i = cart.items.length; i >= 1; i--) {
          (function (line, item) {
            if (!propertiesNeedHeal(item.properties)) return;
            chain = chain.then(function () {
              return healCartLine(item, line).then(function () {
                return true;
              });
            });
          })(i, cart.items[i - 1]);
        }
        return chain;
      })
      .catch(function () {
        return false;
      });
  }

  /* ---------- Calendar (no typing) ---------- */

  var MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];
  var DOW = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

  function parseGregorian(value) {
    if (!value) return null;
    var v = String(value).trim();
    if (!v) return null;
    if (/^\d{4}-\d{2}-\d{2}/.test(v)) {
      var iso = new Date(v + (v.length === 10 ? 'T12:00:00' : ''));
      return isNaN(iso.getTime()) ? null : iso;
    }
    var slash = v.match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{4})$/);
    if (slash) {
      var a = parseInt(slash[1], 10);
      var b = parseInt(slash[2], 10);
      var y = parseInt(slash[3], 10);
      var month = a;
      var day = b;
      if (a > 12) {
        month = b;
        day = a;
      }
      var d = new Date(y, month - 1, day, 12, 0, 0);
      if (d.getFullYear() !== y || d.getMonth() !== month - 1 || d.getDate() !== day) return null;
      return d;
    }
    return null;
  }

  function toMDY(date) {
    var m = String(date.getMonth() + 1).padStart(2, '0');
    var d = String(date.getDate()).padStart(2, '0');
    return m + '/' + d + '/' + date.getFullYear();
  }

  function toHijriString(date) {
    try {
      var fmt = new Intl.DateTimeFormat('en-US-u-ca-islamic-umalqura', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });
      return fmt.format(date).replace(/\s*AH\s*$/i, '').trim() + ' AH';
    } catch (e) {
      try {
        var fmt2 = new Intl.DateTimeFormat('en-US-u-ca-islamic', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        });
        return fmt2.format(date).replace(/\s*AH\s*$/i, '').trim() + ' AH';
      } catch (e2) {
        return null;
      }
    }
  }

  function closeAllCalendars() {
    document.querySelectorAll('.qc-cal.is-open').forEach(function (c) {
      c.classList.remove('is-open');
    });
  }

  function bindCalendar(input) {
    if (!input || input.dataset.qcCal === '1') return;
    input.dataset.qcCal = '1';
    input.classList.add('qc-date-gregorian');
    input.readOnly = true;
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('inputmode', 'none');
    input.setAttribute('placeholder', 'Select a date');
    input.style.cursor = 'pointer';

    var wrap = input.closest('.gpo-input-wrap') || input.parentElement;
    if (!wrap) return;
    wrap.classList.add('qc-date-wrap');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'qc-cal-trigger';
    btn.setAttribute('aria-label', 'Open calendar');
    btn.innerHTML =
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" stroke-width="1.5"/><path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
    wrap.appendChild(btn);

    var cal = document.createElement('div');
    cal.className = 'qc-cal';
    cal.setAttribute('role', 'dialog');
    cal.setAttribute('aria-label', 'Choose a date');
    wrap.appendChild(cal);

    var view = parseGregorian(input.value) || new Date();
    view = new Date(view.getFullYear(), view.getMonth(), 1);

    function render() {
      var selected = parseGregorian(input.value);
      var y = view.getFullYear();
      var m = view.getMonth();
      var firstDow = new Date(y, m, 1).getDay();
      var daysInMonth = new Date(y, m + 1, 0).getDate();
      var today = new Date();
      today.setHours(12, 0, 0, 0);

      var html = '';
      html += '<div class="qc-cal__head">';
      html += '<button type="button" class="qc-cal__nav" data-dir="-1" aria-label="Previous month">‹</button>';
      html += '<div class="qc-cal__title">' + MONTHS[m] + ' ' + y + '</div>';
      html += '<button type="button" class="qc-cal__nav" data-dir="1" aria-label="Next month">›</button>';
      html += '</div>';
      html += '<div class="qc-cal__dow">';
      for (var i = 0; i < 7; i++) html += '<span>' + DOW[i] + '</span>';
      html += '</div><div class="qc-cal__grid">';

      for (var b = 0; b < firstDow; b++) html += '<span class="qc-cal__day is-empty"></span>';
      for (var day = 1; day <= daysInMonth; day++) {
        var d = new Date(y, m, day, 12, 0, 0);
        var cls = 'qc-cal__day';
        if (
          selected &&
          d.getFullYear() === selected.getFullYear() &&
          d.getMonth() === selected.getMonth() &&
          d.getDate() === selected.getDate()
        ) {
          cls += ' is-selected';
        }
        if (
          d.getFullYear() === today.getFullYear() &&
          d.getMonth() === today.getMonth() &&
          d.getDate() === today.getDate()
        ) {
          cls += ' is-today';
        }
        html +=
          '<button type="button" class="' +
          cls +
          '" data-day="' +
          day +
          '">' +
          day +
          '</button>';
      }
      html += '</div>';
      html += '<div class="qc-cal__foot"><button type="button" class="qc-cal__today">Today</button></div>';
      cal.innerHTML = html;
    }

    function open() {
      closeAllCalendars();
      var cur = parseGregorian(input.value);
      if (cur) view = new Date(cur.getFullYear(), cur.getMonth(), 1);
      render();
      cal.classList.add('is-open');
    }

    function pick(day) {
      var d = new Date(view.getFullYear(), view.getMonth(), day, 12, 0, 0);
      setNativeValue(input, toMDY(d), false);
      cal.classList.remove('is-open');
      input.dispatchEvent(new Event('blur', { bubbles: true }));
    }

    /* Open only (idempotent). Do not toggle on input click — focus + click
       used to open then immediately close (needed a second click). */
    function openFromField(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      open();
    }

    function toggleButton(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (cal.classList.contains('is-open')) cal.classList.remove('is-open');
      else open();
    }

    btn.addEventListener('click', toggleButton);
    input.addEventListener('click', openFromField);
    input.addEventListener('pointerdown', function (e) {
      /* Stop document listener from treating this as an outside click */
      e.stopPropagation();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
        e.preventDefault();
        open();
      }
      /* Block typing */
      if (e.key.length === 1 && !e.metaKey && !e.ctrlKey) e.preventDefault();
    });

    cal.addEventListener('click', function (e) {
      e.stopPropagation();
      var t = e.target;
      if (t.closest('[data-dir]')) {
        var dir = parseInt(t.closest('[data-dir]').getAttribute('data-dir'), 10);
        view = new Date(view.getFullYear(), view.getMonth() + dir, 1);
        render();
        return;
      }
      if (t.classList.contains('qc-cal__today')) {
        var now = new Date();
        view = new Date(now.getFullYear(), now.getMonth(), 1);
        pick(now.getDate());
        return;
      }
      if (t.classList.contains('qc-cal__day') && t.getAttribute('data-day')) {
        pick(parseInt(t.getAttribute('data-day'), 10));
      }
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) cal.classList.remove('is-open');
    });
  }

  /* ---------- Hijri sync ---------- */

  function syncHijri(form) {
    var gregorian = findField(form, GREGORIAN_LABEL);
    var hijri = findField(form, HIJRI_LABEL);
    if (!gregorian) return;

    bindCalendar(gregorian);
    ensureHint(gregorian, 'gregorian', 'Tap the field to choose a date from the calendar.');

    if (!hijri) return;
    hijri.classList.add('qc-date-hijri');
    ensureHint(
      hijri,
      'hijri',
      'Suggested via Umm al-Qura. Islamic dates can vary by region — please confirm with your local mosque or preferred calendar and edit if needed.'
    );

    function fillFromGregorian() {
      var sourceDate = gregorian.value;
      var date = parseGregorian(sourceDate);
      if (!date) return;
      var hijriStr = toHijriString(date);
      if (!hijriStr) return;

      var prev = hijri.getAttribute('data-qc-autofill');
      var lastSource = hijri.getAttribute('data-qc-autofill-from');
      var current = (hijri.value || '').trim();

      if (!current && lastSource === sourceDate) {
        hijri.setAttribute('data-qc-user-cleared', '1');
        return;
      }
      if (hijri.getAttribute('data-qc-user-cleared') === '1') {
        if (lastSource === sourceDate) return;
        hijri.removeAttribute('data-qc-user-cleared');
      }
      if (current && current !== prev) return;

      setNativeValue(hijri, hijriStr, true);
      hijri.setAttribute('data-qc-autofill', hijriStr);
      hijri.setAttribute('data-qc-autofill-from', sourceDate);
      hijri.removeAttribute('data-qc-user-cleared');
      hijri.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (!gregorian.dataset.qcHijriBound) {
      gregorian.dataset.qcHijriBound = '1';
      gregorian.addEventListener('change', fillFromGregorian);
      gregorian.addEventListener('blur', fillFromGregorian);
    }

    if (!hijri.dataset.qcClearBound) {
      hijri.dataset.qcClearBound = '1';
      hijri.addEventListener(
        'input',
        function () {
          var prev = hijri.getAttribute('data-qc-autofill') || '';
          if (!(hijri.value || '').trim()) {
            hijri.setAttribute('data-qc-user-cleared', '1');
            hijri.removeAttribute('data-qc-autofill');
          } else if (hijri.value !== prev) {
            hijri.removeAttribute('data-qc-autofill');
            hijri.removeAttribute('data-qc-user-cleared');
          }
        },
        true
      );
    }

    if (gregorian.value.replace(/\D/g, '').length >= 8) fillFromGregorian();
  }

  function polishFields(form) {
    var inputs = form.querySelectorAll(
      '.gpo-app input.gpo-text, .gpo-app input[type="text"], .gpo-app textarea'
    );
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var lab = labelText(input);
      if (NAME_LABEL.test(lab) && !input.placeholder) {
        input.placeholder = 'As it should appear on the piece';
        input.setAttribute('autocomplete', 'name');
      }
      if (/city|state|location/i.test(lab) && !input.placeholder) {
        input.placeholder = 'City, State';
      }
      if (/mahr/i.test(lab) && !input.placeholder) {
        input.placeholder = 'Optional';
      }
    }
  }

  function bindOtherDateFields(form) {
    var scope = form && form.querySelectorAll ? form : document;
    var inputs = scope.querySelectorAll('.gpo-app input[type="text"], .gpo-app input.gpo-text');
    for (var i = 0; i < inputs.length; i++) {
      var lab = labelText(inputs[i]);
      if (GREGORIAN_LABEL.test(lab) || /date of event|event date|wedding date/i.test(lab)) {
        bindCalendar(inputs[i]);
      }
    }
  }

  /*
    Native <select> menus can open at the wrong place on mobile (top-left)
    inside Dawn + Globo. Replace the visible UI with a listbox we position
    under the field; keep the real <select> for form values / Globo.
  */
  function closeAllCustomSelects(except) {
    document.querySelectorAll('.qc-select.is-open').forEach(function (el) {
      if (except && el === except) return;
      el.classList.remove('is-open');
      var btn = el.querySelector('.qc-select__button');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function bindCustomSelect(select) {
    if (!select || select.dataset.qcSelect === '1') return;
    select.dataset.qcSelect = '1';

    var host = select.closest('.gpo-select') || select.parentElement;
    if (!host) return;
    host.classList.add('qc-select');

    select.classList.add('qc-select__native');
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'qc-select__button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    if (select.id) button.setAttribute('aria-controls', select.id + '-qc-list');

    var list = document.createElement('ul');
    list.className = 'qc-select__list';
    list.setAttribute('role', 'listbox');
    list.id = (select.id || 'qc-select') + '-qc-list';

    function selectedLabel() {
      var opt = select.options[select.selectedIndex];
      if (!opt || opt.disabled || !opt.value) {
        return (select.querySelector('option[disabled]') || select.options[0] || {}).textContent ||
          'Please select';
      }
      return (opt.textContent || '').trim();
    }

    function syncButton() {
      var label = selectedLabel().replace(/\s+/g, ' ').trim();
      button.textContent = label;
      button.classList.toggle('is-placeholder', !select.value);
      Array.prototype.forEach.call(list.querySelectorAll('[role="option"]'), function (li) {
        var on = li.getAttribute('data-value') === select.value;
        li.setAttribute('aria-selected', on ? 'true' : 'false');
        li.classList.toggle('is-selected', on);
      });
    }

    function buildList() {
      list.innerHTML = '';
      Array.prototype.forEach.call(select.options, function (opt) {
        if (opt.disabled && !opt.value) return;
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.setAttribute('data-value', opt.value);
        li.setAttribute('tabindex', '-1');
        li.textContent = (opt.textContent || '').trim();
        if (opt.disabled) {
          li.setAttribute('aria-disabled', 'true');
          li.classList.add('is-disabled');
        }
        list.appendChild(li);
      });
      syncButton();
    }

    function open() {
      closeAllCustomSelects(host);
      closeAllCalendars();
      host.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      var selected = list.querySelector('[aria-selected="true"]') || list.querySelector('[role="option"]');
      if (selected) selected.focus();
    }

    function close() {
      host.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
    }

    function choose(value) {
      if (value == null) return;
      var matched = false;
      Array.prototype.forEach.call(select.options, function (opt) {
        if (opt.value === value) {
          opt.selected = true;
          matched = true;
        }
      });
      if (!matched) return;
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
      syncButton();
      close();
      button.focus();
    }

    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (host.classList.contains('is-open')) close();
      else open();
    });

    list.addEventListener('click', function (e) {
      e.stopPropagation();
      var li = e.target.closest('[role="option"]');
      if (!li || li.getAttribute('aria-disabled') === 'true') return;
      choose(li.getAttribute('data-value'));
    });

    button.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        open();
      }
    });

    list.addEventListener('keydown', function (e) {
      var options = Array.prototype.slice.call(
        list.querySelectorAll('[role="option"]:not([aria-disabled="true"])')
      );
      var idx = options.indexOf(document.activeElement);
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
        button.focus();
        return;
      }
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        (options[Math.min(idx + 1, options.length - 1)] || options[0]).focus();
        return;
      }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        (options[Math.max(idx - 1, 0)] || options[0]).focus();
        return;
      }
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (document.activeElement && document.activeElement.getAttribute('data-value') != null) {
          choose(document.activeElement.getAttribute('data-value'));
        }
      }
    });

    select.addEventListener('change', syncButton);
    buildList();
    host.appendChild(button);
    host.appendChild(list);

    if (!document.documentElement.dataset.qcSelectDoc) {
      document.documentElement.dataset.qcSelectDoc = '1';
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.qc-select')) closeAllCustomSelects();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeAllCustomSelects();
      });
    }
  }

  function bindCustomSelects(form) {
    var scope = form && form.querySelectorAll ? form : document;
    var selects = scope.querySelectorAll('.gpo-app select');
    for (var i = 0; i < selects.length; i++) bindCustomSelect(selects[i]);
  }

  function enhance(form) {
    if (!form) return;
    var root =
      form.classList && form.classList.contains('gpo-app')
        ? form
        : form.querySelector('.gpo-app') || form;
    form.classList.add('qc-gpo-enhanced');
    rewritePropertyNames(root);
    polishFields(form);
    syncHijri(form);
    bindOtherDateFields(form);
    bindCustomSelects(form);
  }

  document.addEventListener('gpoRenderCompleted', function (event) {
    enhance(event.detail && event.detail.form);
  });

  document.addEventListener('gpoElementChanged', function () {
    var gpo = document.querySelector('.gpo-app');
    if (!gpo) return;
    rewritePropertyNames(gpo);
    syncHijri(gpo.closest('form') || gpo);
    bindCustomSelects(gpo.closest('form') || gpo);
  });

  document.addEventListener('gpoValidated', function (event) {
    var root = document.querySelector('.gpo-app');
    if (!root) return;
    rewritePropertyNames(root);
    if (event.detail && event.detail.success === false) {
      root.classList.add('qc-gpo-invalid');
    } else {
      root.classList.remove('qc-gpo-invalid');
    }
  });

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.querySelector) return;
      if (!form.querySelector('.gpo-app')) return;
      rewritePropertyNames(form);
    },
    true
  );

  /* ---------- Intercept cart/add (fetch + XHR + FormData) ---------- */

  function rewriteFormData(fd) {
    if (!fd || typeof FormData === 'undefined' || !(fd instanceof FormData)) return fd;
    var map = getLabelMap();
    var entries = [];
    fd.forEach(function (value, key) {
      entries.push([key, value]);
    });
    var next = new FormData();
    var touched = false;
    entries.forEach(function (pair) {
      var key = pair[0];
      var value = pair[1];
      var m = key.match(/^properties\[([^\]]+)\]$/);
      if (m) {
        var inner = m[1];
        if (INTERNAL_PROP.test(inner) && map[inner]) {
          key = 'properties[' + map[inner] + ']';
          touched = true;
        }
        if (/^processing time$/i.test(inner) && typeof value === 'string') {
          var nv = normalizeProcessingValue(value);
          if (nv !== value) {
            value = nv;
            touched = true;
          }
        }
      }
      next.append(key, value);
    });
    return touched ? next : fd;
  }

  function rewriteJsonBody(text) {
    try {
      var data = JSON.parse(text);
      var changed = false;
      if (data.properties) {
        var p = remapPropertiesObject(data.properties);
        if (p !== data.properties) {
          data.properties = p;
          changed = true;
        }
      }
      if (Array.isArray(data.items)) {
        data.items = data.items.map(function (item) {
          if (item.properties) {
            var ip = remapPropertiesObject(item.properties, item.title);
            if (ip !== item.properties) {
              item.properties = ip;
              changed = true;
            }
          }
          return item;
        });
      }
      return changed ? JSON.stringify(data) : text;
    } catch (e) {
      return text;
    }
  }

  function rewriteUrlEncoded(text) {
    try {
      var params = new URLSearchParams(text);
      var map = getLabelMap();
      var next = new URLSearchParams();
      var changed = false;
      params.forEach(function (value, key) {
        var m = key.match(/^properties\[([^\]]+)\]$/);
        if (m && INTERNAL_PROP.test(m[1]) && map[m[1]]) {
          key = 'properties[' + map[m[1]] + ']';
          changed = true;
        }
        if (m && /^processing time$/i.test(m[1])) {
          var nv = normalizeProcessingValue(value);
          if (nv !== value) {
            value = nv;
            changed = true;
          }
        }
        next.append(key, value);
      });
      return changed ? next.toString() : text;
    } catch (e) {
      return text;
    }
  }

  function maybeRewriteBody(url, body) {
    if (!url || !/\/cart\/(add|change)/.test(url) || body == null) return body;
    if (typeof FormData !== 'undefined' && body instanceof FormData) return rewriteFormData(body);
    if (typeof body === 'string') {
      if (body.charAt(0) === '{' || body.charAt(0) === '[') return rewriteJsonBody(body);
      if (body.indexOf('properties[') !== -1) return rewriteUrlEncoded(body);
    }
    return body;
  }

  if (window.fetch) {
    var _fetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : input && input.url;
        if (init && init.body != null) {
          var rewritten = maybeRewriteBody(url, init.body);
          if (rewritten !== init.body) {
            init = Object.assign({}, init, { body: rewritten });
          }
        }
        var p = _fetch(input, init);
        if (url && /\/cart\/add/.test(url)) {
          return p.then(function (res) {
            setTimeout(function () {
              healCartProperties();
            }, 400);
            return res;
          });
        }
        return p;
      } catch (err) {
        return _fetch(input, init);
      }
    };
  }

  if (window.XMLHttpRequest) {
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._qcUrl = url;
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      try {
        body = maybeRewriteBody(this._qcUrl, body);
        if (this._qcUrl && /\/cart\/add/.test(String(this._qcUrl))) {
          this.addEventListener('load', function () {
            setTimeout(function () {
              healCartProperties();
            }, 400);
          });
        }
      } catch (err) {
        /* ignore */
      }
      return _send.call(this, body);
    };
  }

  function moneyFromCents(cents) {
    var amount = Math.max(0, cents) / 100;
    if (amount % 1 === 0) return '$' + amount;
    return '$' + amount.toFixed(2);
  }

  function renderPdpShip(root, priceCents) {
    var cartCents = parseInt(root.getAttribute('data-qc-cart-cents'), 10) || 0;
    var projected = cartCents + priceCents;
    var ship = 7500;
    var goal = 10000;
    var basis = cartCents >= goal ? cartCents : projected;
    var pct = Math.max(0, Math.min(100, Math.round((basis / goal) * 100)));
    var msg = root.querySelector('[data-qc-ship-msg]');
    var fill = root.querySelector('[data-qc-ship-fill]');
    var bar = root.querySelector('[data-qc-ship-progress]');
    if (!msg || !fill) return;
    if (cartCents >= goal) {
      msg.innerHTML = 'Your cart qualifies for <strong>free shipping</strong> and <strong>$10 off</strong> with code 10OFF100';
      root.classList.add('qc-ship-bar--met');
    } else if (projected >= goal) {
      msg.innerHTML = 'Adding this covers <strong>free shipping</strong> and <strong>$10 off</strong> with code 10OFF100';
      root.classList.add('qc-ship-bar--met');
    } else if (cartCents >= ship) {
      msg.innerHTML = 'Free shipping is covered. Adding this, you are <strong>' + moneyFromCents(goal - projected) + '</strong> away from $10 off';
      root.classList.remove('qc-ship-bar--met');
    } else if (projected >= ship) {
      msg.innerHTML = 'Adding this covers <strong>free shipping</strong>. You would still be <strong>' + moneyFromCents(goal - projected) + '</strong> from $10 off';
      root.classList.remove('qc-ship-bar--met');
    } else {
      msg.innerHTML = 'Adding this, you are <strong>' + moneyFromCents(ship - projected) + '</strong> away from free shipping';
      root.classList.remove('qc-ship-bar--met');
    }
    fill.style.width = pct + '%';
    if (bar) bar.setAttribute('aria-valuenow', String(pct));
  }

  function bootPdpShip() {
    var root = document.querySelector('[data-qc-pdp-ship]');
    if (!root) return;
    var dataEl = root.querySelector('[data-qc-pdp-variants]');
    if (!dataEl) return;
    var variants = {};
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data ? event.data : event;
      var variant = data && (data.variant || (data.data && data.data.variant));
      if (!variant || variant.id == null || variants[String(variant.id)] == null) return;
      root.setAttribute('data-qc-variant-id', String(variant.id));
      renderPdpShip(root, variants[String(variant.id)]);
    });
  }

  function boot() {
    var existing = document.querySelector('.gpo-app');
    if (existing) enhance(existing.closest('form') || existing);
    /*
      Heal text-1 lines on cart (and any page with a cart) so checkout inherits labels.
      Do not intercept the checkout button — form.submit() without name=checkout was
      blocking checkout earlier; heal-on-load + ATC intercept is enough.
    */
    bootPdpShip();
    healCartProperties().then(function (healed) {
      if (!healed) return;
      if (location.pathname.indexOf('/cart') === -1) return;
      if (sessionStorage.getItem('qcCartHealed') === '1') return;
      sessionStorage.setItem('qcCartHealed', '1');
      location.reload();
    });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
